module.exports = {"211011002":"望水台街道","211011003":"铁西街道","211011101":"祁家镇","211011102":"沙岭镇","211011103":"王家镇","211011204":"东宁卫乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211011.json
// module id = 575
// module chunks = 0